import { useTranslation } from 'react-i18next';
import { UserTagOptionDataFragment } from '../../../../api';
import OutlinedMultiSelectField from '../../../../components/fields/OutlinedMultiSelectField';

type TagSelectionProps = {
    tags: UserTagOptionDataFragment[];
    onSelectionChange?: (selectedIds: string[]) => void;
};

const TagSelection = ({ tags, onSelectionChange }: TagSelectionProps) => {
    const { t } = useTranslation(['purchaseTransactionsPage', 'common']);

    return (
        <OutlinedMultiSelectField<UserTagOptionDataFragment>
            color="secondary"
            getOptionLabel={tag => tag.name}
            label={t('purchaseTransactionsPage:quotation.inviteQuote.dealerTagged')}
            name="tagIds"
            noOptionsText={t('common:noTags')}
            onSelectionChange={onSelectionChange}
            options={tags}
            placeholder={t('common:searchTags')}
            renderOption={tag => tag.name}
        />
    );
};

export default TagSelection;
